module.exports = __webpack_public_path__ + "static/media/no_creatives.68c9ad66.svg";